export const capitalize = text => {
  return text?.length >= 2 ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : '';
};
